
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/community",
      function () {
        return require("private-next-pages/[locale]/community/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/community"])
      });
    }
  